import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClientWH } from '@shared/services/ApiClient';
import { createHttpClient } from '@adapters/HttpClient';
import {
  ExternalProductsApiAdapter,
  type ExternalExcludedProduct,
  type CreateExclusionPayload,
} from '../adapters/ExternalProductsApiAdapter';

/**
 * Hook para obtener la lista de productos externos excluidos
 */
export const useExternalExcludedProducts = (shopId?: number) => {
  const adapter = new ExternalProductsApiAdapter(createHttpClient(apiClientWH));

  console.log('🔍 useExternalExcludedProducts - Hook called:', { shopId });

  return useQuery({
    queryKey: ['externalExcludedProducts', shopId],
    queryFn: () => {
      console.log('🔍 useExternalExcludedProducts - Query function called:', { shopId });
      return adapter.getExcludedProducts(shopId);
    },
    staleTime: 1 * 60 * 1000, // 1 minuto
    gcTime: 5 * 60 * 1000, // 5 minutos
  });
};

/**
 * Hook para crear una exclusión de producto externo
 */
export const useCreateExclusion = () => {
  const queryClient = useQueryClient();
  const adapter = new ExternalProductsApiAdapter(createHttpClient(apiClientWH));

  return useMutation({
    mutationFn: (payload: CreateExclusionPayload) =>
      adapter.createExclusion(payload),
    onSuccess: () => {
      // Invalidar la query para refrescar la lista
      queryClient.invalidateQueries({
        queryKey: ['externalExcludedProducts'],
      });
    },
  });
};

/**
 * Hook para eliminar una exclusión de producto externo
 */
export const useDeleteExclusion = () => {
  const queryClient = useQueryClient();
  const adapter = new ExternalProductsApiAdapter(createHttpClient(apiClientWH));

  return useMutation({
    mutationFn: (id: number) => adapter.deleteExclusion(id),
    onSuccess: () => {
      // Invalidar la query para refrescar la lista
      queryClient.invalidateQueries({
        queryKey: ['externalExcludedProducts'],
      });
    },
  });
};
